import api from './api';

export interface IntakeFormData {
  [key: string]: any;
}

export interface IntakeForm {
  id: number;
  unique_token: string;
  case_id?: number;
  status: string;
  form_data?: IntakeFormData;
  created_at: string;
  updated_at: string;
}

export interface IntakeFormSubmitResponse {
  message: string;
  intake_form: IntakeForm;
  pdf_generated: boolean;
  pdf_filepath?: string;
  pdf_filename?: string;
  download_url?: string;
  error?: string;
}

class IntakeFormService {
  async getByToken(token: string): Promise<IntakeForm> {
    const response = await api.get(`/intake-form/${token}`);
    return response.data;
  }

  async updateByToken(
    token: string,
    data: IntakeFormData
  ): Promise<IntakeForm> {
    const response = await api.put(`/intake-form/${token}`, data);
    return response.data.intake_form;
  }

  async submit(token: string): Promise<IntakeFormSubmitResponse> {
    const response = await api.post(`/intake-form/${token}/submit`);
    return response.data;
  }

  async createForCase(
    caseId: number
  ): Promise<{ intake_form: IntakeForm; public_url: string }> {
    const response = await api.post(`/cases/${caseId}/intake-form`);
    return response.data;
  }

  async getAll(): Promise<IntakeForm[]> {
    const response = await api.get('/admin/intake-forms');
    return response.data;
  }

  async getById(id: number): Promise<IntakeForm> {
    const response = await api.get(`/admin/intake-forms/${id}`);
    return response.data;
  }

  async getIntakeFormLinks(caseId: number): Promise<{
    case: any;
    intake_form_links: Array<{
      intake_form_type: any;
      intake_form: IntakeForm;
      public_url: string;
      is_required: boolean;
      sort_order: number;
      status: string;
    }>;
  }> {
    const response = await api.get(`/cases/${caseId}/intake-form-links`);
    return response.data;
  }

  async downloadIntakeFormPdf(caseId: number): Promise<Blob> {
    const response = await api.get(
      `/cases/${caseId}/download-intake-form-pdf`,
      {
        responseType: 'blob',
      }
    );
    return response.data;
  }

  async generateIntakeFormPdf(caseId: number): Promise<{
    message: string;
    filepath: string;
    filename: string;
    download_url: string;
  }> {
    const response = await api.post(
      `/cases/${caseId}/generate-intake-form-pdf`
    );
    return response.data;
  }
}

export const intakeFormService = new IntakeFormService();
